var trackEvent;

module.exports = trackEvent = function(eventName, payload) {
  var defaults, ref;
  if (payload == null) {
    payload = {};
  }
  defaults = {
    b: Cookie.get('b'),
    pageId: location.pathname
  };
  payload = _.extend({}, payload, defaults);
  if (typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null) {
    if ((ref = OptimizeSuite.TrackingHub) != null) {
      ref.add("" + eventName, payload);
    }
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL3RyYWNrRXZlbnQuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL3RyYWNrRXZlbnQuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLElBQUE7O0FBQUEsTUFBTSxDQUFDLE9BQVAsR0FBaUIsVUFBQSxHQUFhLFNBQUMsU0FBRCxFQUFZLE9BQVo7QUFDNUIsTUFBQTs7SUFEd0MsVUFBVTs7RUFDbEQsUUFBQSxHQUNFO0lBQUEsQ0FBQSxFQUFHLE1BQU0sQ0FBQyxHQUFQLENBQVcsR0FBWCxDQUFIO0lBQ0EsTUFBQSxFQUFRLFFBQVEsQ0FBQyxRQURqQjs7RUFFRixPQUFBLEdBQVUsQ0FBQyxDQUFDLE1BQUYsQ0FBUyxFQUFULEVBQWEsT0FBYixFQUFzQixRQUF0Qjs7O1NBRWdCLENBQUUsR0FBNUIsQ0FBZ0MsRUFBQSxHQUFHLFNBQW5DLEVBQWdELE9BQWhEOzs7QUFONEIifQ==
